import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Form from "../../../Reusable/Form/Form.js";
import ContactUsFields from "../ContactUsFields.js";
import queryString from "query-string";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

import "./contactUsForm.scss";

const ContactrUsForm = ({ setIfSuccess, setHideForm }) => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const [contactTitle, setContactTitle] = useState(null);
  const { contactUs, getUserData, isLoggedIn } = useUser();
  const { addToast } = useToasts();

  const location = useLocation();

  useEffect(() => {
    const searchParams = queryString.parse(location.search);
    const subjectType = searchParams.subject;
    //Check if Moved to the Contact-Page Not from Footer
    if (subjectType) {
      switch (subjectType) {
        case "support":
          setContactTitle({ constKey: "upper-SUPPORT", value: "Support" });
          setHideForm(true);
          break;
        case "sales":
          setContactTitle({ constKey: "sales", value: "Sales" });
          setHideForm(true);
          break;
        case "payments":
          setContactTitle({ constKey: "paymants", value: "Payments" });
          setHideForm(true);
          break;
        case "suggestions":
          setContactTitle({ constKey: "suggestions", value: "Suggestions" });
          setHideForm(true);
          break;
        case "jumboforms":
          setContactTitle({ constKey: "jumboembed", value: "JUMBOembed" });
          setHideForm(true);
          break;
        case "jumbopay":
          setContactTitle({ constKey: "jumbopay", value: "JUMBOpay" });
          setHideForm(true);
          break;
        case "sub-users":
          setContactTitle({ constKey: "sub-users", value: "Sub Users" });
          setHideForm(true);
          break;
        case "something-else":
          setContactTitle({
            constKey: "something-else",
            value: "Something Else",
          });
          break;
        default:
          break;
      }
    }
  }, []);

  const handleSuccessResponse = () => {
    if (setIfSuccess) {
      setIfSuccess(true);
    } else {
      setHideForm(true);
      addToast(getTextByKey("contact-support-success"), {
        appearance: "success",
      });
    }
  };

  const handleSubmit = async (body) => {
    //Need for Email response API Call
    body.ContactCulture = getLanguageCulture().split("-")[0];
    body.Culture = getLanguageCulture().toLowerCase();
    body.MailType = "ContactUsMail";
    body.userIp = getUserData().User_IP;
    body.platform = getUserData().User_Platform;

    const response = await contactUs(body);
    // notify on successfull submit
    if (response.status === "success") {
      handleSuccessResponse();
      return {
        status: response.status,
      };
    } else {
      setHideForm(true);
      return {
        message: response.message,
        status: response.status,
      };
    }
  };

  return (
    <div className="contact-us-form-wrapper">
      <Form
        id="contact-us-form"
        fields={ContactUsFields}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("send"),
        }}
        buttonProps={{
          buttonsSize: "xs",
          buttonsDirection: "pull-to-start",
        }}
        defaultValuesObj={
          isLoggedIn()
            ? {
                ContactSender: `${getUserData().UserFirstName} ${
                  getUserData().UserLastName
                }`,
                ContactPhone: getUserData().UserPhone,
                ContactEmail: getUserData().UserName,
              }
            : {}
        }
        defaultSelectObj={{ ContactTitle: contactTitle }}
        fieldsProps={{
          label: "contact-message-title",
        }}
        // captchaProvider="cloudflare"
        // cloudflareActionName="contactUs"
      />
    </div>
  );
};

export default ContactrUsForm;
